import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { handleUnauthorized } from "../../TokenAuth/auth";

export const fetchWalletBalanceReport = createAsyncThunk(
    "walletBalance/fetchWalletBalanceReport",
    async ({ page, limit, search, startDate, endDate, mobileNumber }, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem("astroVani-admin-token");
            const params = { page, limit, search, startDate, endDate };
            if (mobileNumber) {
                params.mobileNumber = mobileNumber;
            }
            const response = await axios.get(
                `${process.env.REACT_APP_BASEURL}/admin/walletBalanceReport`,
                {
                    params,
                    headers: {
                        Authorization: token,
                    },
                }
            );

            if (response.status === 401) {
                handleUnauthorized();
                throw new Error("Unauthorized: Please login again");
            }

            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || "Something went wrong"
            );
        }
    }
);

const initialState = {
    data: [],
    totalCount: 0,
    status: "idle",
    error: null,
    paginationDetail: {
        currentPage: 1,
        perPage: 10,
        totalPages: 0,
        totalRecords: 0,
    },
};

const WalletBalanceReportReducer = createSlice({
    name: "walletBalance",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchWalletBalanceReport.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchWalletBalanceReport.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload.data || [];
                state.totalCount = action.payload.totalCount || 0;
                state.paginationDetail = action.payload.paginationDetail || initialState.paginationDetail;
                state.error = null;
            })
            .addCase(fetchWalletBalanceReport.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            });
    },
});

export default WalletBalanceReportReducer.reducer;

